/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { TrackEventRequestProperties } from "./TrackEventRequestProperties";

export interface TrackEventRequest {
  event: string;
  properties?: TrackEventRequestProperties;
  anonymous_id?: string | null;
}
